import { Field } from 'formik';

import { useOptionContext } from '@/resources/hooks/useOptionsContext';

import { useFormatMoney } from '../../../hooks/useFormatMoney';

interface Props {
  quantity: number;
  showSubtotal: boolean;
}

function OptionPrice({ quantity, showSubtotal }: Props) {
  const {
    answer: { value },
  } = useOptionContext();

  const price = useFormatMoney(value, 2);
  const subtotal = useFormatMoney(quantity * value, 2);

  return (
    <div>
      <Field type="hidden" name="value" value={value} />

      {value !== 0 && (
        <div className="d-flex flex-column text-right">
          <span className="mb-0 text-secondary" style={{ fontSize: '8pt' }}>
            + R$ {price}
          </span>

          {showSubtotal && quantity > 0 && (
            <span className="mb-0 " style={{ fontSize: '11pt' }}>
              <span style={{ fontSize: '9pt' }}>R$ </span>
              <span>{subtotal}</span>
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default OptionPrice;
